import { Route, RouteConfig } from "vue-router";

export const dashboardRoutes: Array<RouteConfig> = [
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      breadcrumb: [
        {
       
        },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "../../../views/DashboardView.vue"
      ),
  },
  {
    path: "/notification-test",
    name: "notification-test",
    meta: {
      breadcrumb: [
        {
       
        },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "notification-test" */ "../../../views/NotificationTestView.vue"
      ),
  },
 
];

for (const dashboardRoute of dashboardRoutes) {
  if (!dashboardRoute.meta) {
    dashboardRoute.meta = {};
  }
  dashboardRoute.meta.authRequired = true;
  dashboardRoute.meta.userTypes = ["admin", "super_admin"];
}
